<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
  >
    <g fill="none" fill-rule="evenodd" v-if="active">
      <circle
        cx="20"
        cy="20"
        r="19.389"
        stroke="#122033"
        stroke-width="1.222"
      />
      <g stroke="#000" stroke-width=".611">
        <path
          stroke-linecap="round"
          d="M14.305 25.652h-4.6M18.92 27.47h-7.398M14.305 29.289h-4.6"
        />
        <path stroke-linecap="square" d="M17.93 18.109l4.04 4.04" />
        <path
          d="M13.309 22.687l2.819 2.82 2.986.06 10.593-10.593-4.342-4.343-12.056 12.056z"
        />
      </g>
    </g>

    <g fill="none" fill-rule="evenodd" v-else>
      <circle cx="20" cy="20" r="20" fill="#ADB2B8" opacity=".3" />
      <g stroke="#000" stroke-width=".611" opacity=".4">
        <path
          stroke-linecap="round"
          d="M14.305 25.652h-4.6M18.92 27.47h-7.398M14.305 29.289h-4.6"
        />
        <path stroke-linecap="square" d="M17.93 18.109l4.04 4.04" />
        <path
          d="M13.309 22.687l2.819 2.82 2.986.06 10.593-10.593-4.342-4.343-12.056 12.056z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
};
</script>

<style></style>
